/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

import { Box, CircularProgress } from '@mui/material';
import React, { ReactElement, useEffect, useState } from 'react';
import LegalTextView from '../../../components/LegalText/LegalTextView';
import { useViewModel } from '../../../hooks/useViewModel';
import { PrivacyPolicyViewModel } from './PrivacyPolicyViewModel';
import PrivacyPolicyViewStyles from './PrivacyPolicyViewStyles';

export default function PrivacyPolicyView(): ReactElement {
	const { classes } = PrivacyPolicyViewStyles();
	const viewModel: PrivacyPolicyViewModel = useViewModel(PrivacyPolicyViewModel);
	const [privacyPolicy, setPrivacyPolicy] = useState('');

	useEffect(() => {
		getPrivacyPolicy();
	}, []);

	async function getPrivacyPolicy() {
		const res = await viewModel.queryPrivacyPolicy();
		if (typeof res === 'string') {
			setPrivacyPolicy(res);
		}
	}

	return (
		<>
			{viewModel.isLoading() ? (
				<Box className={classes.loadingContainer}>
					<CircularProgress className={classes.loading} />
				</Box>
			) : (
				<LegalTextView content={privacyPolicy} />
			)}
		</>
	);
}
